import { createSelector } from "reselect";

import { State as AppState, StateKeys } from "rivals/redux/reducer";
import { selectSubscribableAddOns } from "rivals/redux/subscriptionAddons/selectors";
import { AddOns } from "rivals/shared/interfaces/AddOn";
import { State } from "./reducer";

const getRegistrationState = (state: AppState): State =>
  state[StateKeys.REGISTRATION];

export const getError = createSelector(
  getRegistrationState,
  state => state.error
);

export const getGiftInfo = createSelector(
  getRegistrationState,
  state => state.giftInfo
);

export const getGiftPricing = createSelector(
  getRegistrationState,
  state => state.giftPricing
);

export const selectGiftPricingError = createSelector(
  getRegistrationState,
  state => state.giftPricingError
);

export const getGiftSubdomain = createSelector(
  getRegistrationState,
  state => state.giftSubdomain
);

export const getGiftToken = createSelector(
  getRegistrationState,
  state => state.giftToken
);

export const getPublisherLetter = createSelector(
  getRegistrationState,
  state => state.publisherLetter
);

export const getSubmitting = createSelector(
  getRegistrationState,
  state => state.submitting
);

export const getSentRegistrationParams = createSelector(
  getRegistrationState,
  state => state.registrationParams
);

export const selectAddOnStatus = createSelector(
  getRegistrationState,
  state => state.selectedAddOns
);

// Returns the Selected Add On for the Selected Plan
export const selectSelectedAddOn = createSelector(
  selectAddOnStatus,
  selectSubscribableAddOns,
  (addOnStatus, addOns) =>
    addOns.find(addOn => addOnStatus[addOn.name as AddOns])
);
